import {defineStore} from 'pinia';
import {ref} from 'vue';
import {useUserStore} from '@/ts/store/user-store';
import {hashString} from '@/ts/utils/pure-functions';

const LOCAL_STORAGE_KEY = 'confirmed-alerts';

function getFromStorage(): string[] {
  try {
    const parsedConfirmedMessages: unknown = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) ?? '');
    if (!Array.isArray(parsedConfirmedMessages)) {
      return [];
    }
    // Filter out falsy values and cast to string[]
    return parsedConfirmedMessages.filter((item) => Boolean(item)) as string[];
  } catch {
    return [];
  }
}

export const useAlertConfirmationStore =
  /** Tracks which alert messages have been confirmed by the user via localStorage hashes */
  defineStore('alert-confirmation-store', () => {
  const userStore = useUserStore();
  const confirmedAlerts = ref<string[]>(getFromStorage());

  const getHash = async(alertId: string): Promise<string> => {
    return hashString(userStore.userData?.id + alertId);
  };

  const checkWhetherAlertIsAlreadyConfirmed = async(alertId: string): Promise<boolean> => {
    const hash = await getHash(alertId);
    return confirmedAlerts.value.includes(hash);
  };

  const confirmAlert = async(alertId: string): Promise<void> => {
    const hash = await getHash(alertId);
    const confirmedHashes = getFromStorage();
    if (!confirmedHashes.includes(hash)) {
      confirmedHashes.push(hash);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(confirmedHashes));
    }
    confirmedAlerts.value = confirmedHashes;
  };

  return {
    checkWhetherAlertIsAlreadyConfirmed,
    confirmAlert,
  };
});